import Image from "next/image"
import styles from "./tnpsc-group-II-mains-test-series.module.css";
import group2amaintest from "../../assets/images/Tnpsc/TNPSC-GrIIA-Mains-WebBanner.jpg";
import Mobbanner from "../../assets/images/Tnpsc/TNPSC-GrIIA-Mains-MobBanner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2 = () => {
   
    return (
        <>
        <Head>
            <meta charset="UTF-8" />
            <link rel="icon" href="./logo.png" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group IIA Mains Test Series 2024 | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group IIA Mains Test Series 2024 | Shankar IAS Academy" />
            <meta name="description" content="Prepare for success with our TNPSC Group IIA Mains Test Series 2024. Get expert-designed mock tests and detailed solutions for effective exam preparation." />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-IIA-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group IIA Mains Test Series 2024 | Shankar IAS Academy" />
            <meta property="og:description" content="TNPSC Group Ⅱ Main Test Paper Ⅱ | TNPSC Test Series, Online and Offline for Regular and Weekend Batch Students is the Best in Tamil Nadu for Group Ⅱ Mains" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-IIA-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>
        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
                <div className="col pt-3 pt-md-5">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Group IIA Mains Test Series 2024</h1>
                </div>
            </div>

            <div className="row d-none d-md-block">
                <div className="col pt-2 mb-3">
                    <Image src={group2amaintest} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2024 New Test Series" className="img-fluid w-100" />
                </div>
            </div>

            <div className="row  d-block d-md-none">
                <div className="col pt-2 mb-3">
                    <Image src={Mobbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2024 New Test Series" className="img-fluid w-100" />
                </div>
            </div>

            {/*<div className="row pt-2">
                <div className="col-md-9 col-12">
                    <h2 className={`${styles.sectiontitle} mb-0`}>TNPSC Group IIA Mains 2024 New Test Series Paper II</h2>
                </div>

                 <div className="col">
                <Link href="/tnpsc-mains-test-series" ><button className={`${styles.normalbutton1} mt-2 mt-md-0`} type="submit">TNPSC Group II/II-A Mains Paper I </button></Link>
                </div>
            </div>*/}

        </div>


       {/*Desktop table */}
       <div className="container d-none d-lg-block">
        <div className="row pt-3 prelimstable">
        <div className="col">
          <div className={`${styles.tablescroll}`}>
                 <table class="table">
                     <thead class="table" style={{backgroundColor:"#818C98"}}>
                        <tr>
                            <td className={`${styles.tableheading}`}>Center<br/></td>
                            <td className={`${styles.tableheading}`}>Batch<br/></td>
                            <td className={`${styles.tableheading}`}>Starts on<br/></td>
                            <td className={`${styles.tableheading}`}>Fee<br/></td>
                            <td className={`${styles.tableheading}`}>Schedule<br/></td>
                            <td className={`${styles.tableheading}`}>Payment<br/></td>
                        </tr>
                 </thead>
                 <tbody>
                 <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline / Online)</span></p></td>
                            <td className={`${styles.tablepara}`}>24th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p>9,500 (For All Online Students)<br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GT-Offline-&-ONLINE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline / Online)</span></p></td>
                            <td className={`${styles.tablepara}`}>24th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p>9,500 (For All Online Students)<br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GE-Offline-&-ONLINE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline / Online)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>17,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>18,000 (For Offline New Students)</p>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline / Online)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>17,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>18,000 (For Offline New Students)</p>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Trichy<br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline / Online)</span></p></td>
                            <td className={`${styles.tablepara}`}>27th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p>9,500 (For All Online Students)<br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/GR-II-MAINSTEST SCHEDULE-G.T+G.S-TRICHY_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline / Online)</span></p></td>
                            <td className={`${styles.tablepara}`}>27th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p>9,500 (For All Online Students)<br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/GR-II-A-MAINS-TEST-SCHEDULE-(G.E + G.S)-TRICHY_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>


                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Trichy<br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Online Only)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Online Only)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}>(Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Madurai<br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>27th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p><br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group_IIA_Mains_IGNITE_BATCH_GS_with_GT_Offline_madurai_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>27th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p><br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group_IIA_Mains_IGNITE_BATCH_GS_with_GE_Offline_madurai_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Madurai<br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Online Only)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Online Only)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}>(Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Namakkal<br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>28th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Saturday & Sunday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p><br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GT-NAMAKKAL.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>28th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Saturday & Sunday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p><br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GE-NAMAKKAL.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Salem<br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>27th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p><br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GT-Offline-&-ONLINE-salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch IV Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>27th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Tuesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>9,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>9,500 (For Offline New Students)</p><br/></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GE-Offline-&-ONLINE-salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Salem<br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Online Only)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Online Only)</span></p></td>
                            <td className={`${styles.tablepara}`}>15th Dec 2024<br/><p className={`${styles.tablepara}`}>(Every Sunday & Tuesday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>
                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Thiruvarur<br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>16th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Wednesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch III Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Offline)</span></p></td>
                            <td className={`${styles.tablepara}`}>16th Dec 2024<br/><p className={`${styles.tablepara}`}> (Every Wednesday & Friday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr> 

                       



                  {/* <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td className={`${styles.tablepara}`}>Batch II Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Closed)</span></p></td>
                            <td className={`${styles.tablepara}`}>12th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Saturday & Wednesday)</p></td>
                            <td className={`${styles.tablepara}`}>17,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>18,000 (For Offline New Students)</p>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch2-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch II Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Closed)</span></p></td>
                            <td className={`${styles.tablepara}`}>12th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Saturday & Wednesday)</p></td>
                            <td className={`${styles.tablepara}`}>17,000 (For Offline Old Students)<br/><p className={`${styles.tablepara}`}>18,000 (For Offline New Students)</p>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch2-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>


                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Trichy<br/></td>
                            <td className={`${styles.tablepara}`}>Batch II Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Closed)</span></p></td>
                            <td className={`${styles.tablepara}`}>12th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Saturday & Wednesday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch2-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch II Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Closed)</span></p></td>
                            <td className={`${styles.tablepara}`}>12th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Saturday & Wednesday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch2-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>


                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Chennai - Anna Nagar<br/></td>
                            <td className={`${styles.tablepara}`}>Batch I Regular (GT + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Closed)</span></p></td>
                            <td className={`${styles.tablepara}`}>4th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Friday & Tuesday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch1-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch I Regular (GE + GS)<br/><p className={`${styles.tablepara}`}><span style={{color:"#DB1B0D"}}>(Closed)</span></p></td>
                            <td className={`${styles.tablepara}`}>4th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Friday & Tuesday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch1-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>


                      

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}>Thiruvarur<br/></td>
                            <td className={`${styles.tablepara}`}>Batch I Regular (GT + GS)<br/><p className={`${styles.tablepara}`}></p></td>
                            <td className={`${styles.tablepara}`}>7th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Monday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch1-THIRUVARUR.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr>

                        <tr className="pt-2">
                            <td className={`${styles.tablepara}`}><br/></td>
                            <td className={`${styles.tablepara}`}>Batch I Regular (GE + GS)<br/><p className={`${styles.tablepara}`}></p></td>
                            <td className={`${styles.tablepara}`}>7th Oct 2024<br/><p className={`${styles.tablepara}`}> (Every Monday & Thursday)</p></td>
                            <td className={`${styles.tablepara}`}>15,000 (For Online Old Students)<br/><p className={`${styles.tablepara}`}>16,000 (For Online New Students)</p></td>
                            <td><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch1-THIRUVARUR.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                            <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                        </tr> */}

                    </tbody>
              </table>
        </div>
        </div>
    </div>
</div>

{/*Mobile Table */}
<div className="container mt-2 mb-5 d-block d-lg-none">
    <div className="col-12 col-xl-12 ">   
    
                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Chennai - Anna Nagar</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline/Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">24th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students) <br/><br/> 9,500 (For All Online Students)</div> 
 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GT-Offline-&-ONLINE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
    
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Chennai - Anna Nagar</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline/Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">24th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students) <br/><br/> 9,000 (For All Online Students)</div> 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GE-Offline-&-ONLINE.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 

</div>



    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Chennai - Anna Nagar</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Sunday & Tuesday & Thursday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">17,000 (For Offline Old Students)<br/>18,000 (For Offline New Students) <br/><br/> 15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div> 
 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 

</div>


    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Chennai - Anna Nagar</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Sunday & Tuesday & Thursday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">17,000 (For Offline Old Students)<br/>18,000 (For Offline New Students) <br/><br/> 15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div> 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 

</div>
    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Trichy</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline/Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">27th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students) <br/><br/> 9,500 (For All Online Students)</div> 
 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/GR-II-MAINSTEST SCHEDULE-G.T+G.S-TRICHY_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Trichy</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline/Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">27th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students) <br/><br/> 9,000 (For All Online Students)</div> 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/GR-II-A-MAINS-TEST-SCHEDULE-(G.E + G.S)-TRICHY_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Trichy</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Sunday & Tuesday & Thursday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>


    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Trichy</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Saturday & Wednesday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>
    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Madurai</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">27th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students)</div> 
 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group_IIA_Mains_IGNITE_BATCH_GS_with_GT_Offline_madurai_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Madurai</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">27th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students)</div> 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group_IIA_Mains_IGNITE_BATCH_GS_with_GE_Offline_madurai_compressed.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>
    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Madurai</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Sunday & Tuesday & Thursday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   
      
                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Madurai</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Saturday & Wednesday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
         
</div>
    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Namakkal</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">28th Dec 2024 <br/>(Every Saturday & Sunday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students)</div> 
 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GT-NAMAKKAL.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Namakkal</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">28th Dec 2024 <br/>(Every Saturday & Sunday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students)</div> 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GE-NAMAKKAL.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>
    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6  col-md-3">Thiruvarur</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Offline / Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">16th Dec 2024 <br/>(Every Wednesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GT+GS-Batch3-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6  col-md-3">Thiruvarur</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">16th Dec 2024 <br/>(Every Wednesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>
    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6 col-md-3">Salem</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">27th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students)</div> 
 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Group-IIA-Mains-IGNITE-BATCH-GS-with-GT-Offline-&-ONLINE-salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6"><b>Center</b></div>
                    <div class="col-6 col-md-3">Salem</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch IV - Offline (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">27th Dec 2024 <br/>(Every Tuesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">9,000 (For Offline Old Students)<br/>9,500 (For Offline New Students)</div> 
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Group-IIA-Mains-IGNITE-BATCH-GS-with-GE-Offline-&-ONLINE-salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
</div>

    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6  col-md-3">Salem</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Offline / Online (GT + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Wednesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 

</div>


    <div className="col-12 col-xl-12 ">   

                <div className="row border-bottom pt-3 ">
                            
                    <div class="col-6 "><b>Center</b></div>
                    <div class="col-6  col-md-3">Salem</div>
                            
                    <div class="col-6 pt-3"><b>Batch</b></div>
                    <div class="col-6 pt-3 col-md-3">Batch III - Online (GE + GS)</div>
                            
                    <div class="col-6 pt-3"><b>Starts On</b></div>
                    <div class="col-6 pt-3 col-md-3">15th Dec 2024 <br/>(Every Wednesday & Friday)</div>
                            
                    <div class="col-6 pt-3"><b>Fees</b></div>
                    <div class="col-6 pt-3 col-md-3">15,000 (For Online Old Students)<br/>16,000 (For Online New Students)</div>
                            
                    <div class="col-6 pt-3"><b>Schedule</b></div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/pdf/Tnpsc-GIIA-Mains-2024/Tnpsc-GrIIA-Mains-GE+GS-Batch3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></b></div>

                    <div class="col-6 pt-3"><b>Admission</b></div>
                    <div class="col-6 pt-3 pb-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
      
    </div>
</div>




 



<Interest />
<Footer />

        </>
    )
}

export default Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2
